import React, { useEffect, useState } from 'react';
import { LayoutWrapperMain, LayoutWrapperTopbar, Page } from '../../components';
import css from './ShoppingCart.module.css';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { StorePurchase, ShippingModal } from './Components';
import NamedLinkButton from '../../components/NamedLink/NamedLinkButton/NamedLinkButton';

import { changeAmount, getItems, removeItem, shippingFeeCalculation } from './ShoppingCart.duck';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { compose } from 'redux';
import { initiateOrder } from '../CheckoutPage/CheckoutPage.duck';
import { withRouter } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import image from '../../assets/404.svg';

function ShoppingCart(props) {
  const topbar = <TopbarContainer />;
  const {
    retrieveItems,
    cartItems,
    loading,
    removeItem,
    editAmount,
    intl,
    calculateShipping,
    cart,
    history,
    currentUser,
  } = props;
  const [isOpen, setIsOpen] = useState({ isOpen: false, sellerId: '' });

  const initialCountries = () => {
    const countriesObj = {};
    cartItems.data?.forEach(store => (countriesObj[store.sellerId] = 'US'));
    return countriesObj;
  };

  const [country, setCountry] = useState({});
  const intersection = arrays => {
    return arrays[0].filter(elem => arrays.every(array => array.includes(elem)));
  };

  const handleOpenModal = (e, products) => {
    const arrays = products.map(product =>
      product.attributes.publicData.countries?.length > 0
        ? product.attributes.publicData.countries?.map(country => country.country)
        : ['RoW']
    );

    const countries = intersection(arrays);
    setIsOpen({
      isOpen: true,
      sellerId: e.target.id,
      sellerShippingCountries: countries,
    });
  };

  useEffect(() => {
    let countryToUse = country === {} ? initialCountries() : country;
    cartItems?.data &&
      cartItems.data.map(item => {
        calculateShipping(
          item.products,
          item.sellerId,
          item.sellerShippingData,
          countryToUse ? countryToUse[item.sellerId] : 'US'
        );
      });
  }, [cartItems, country]);

  const handleSubmit = (e, newCountry, sellerId) => {
    // logic for submiting the region for estimating shipping
    e.preventDefault();
    setCountry(prev => ({ ...prev, [sellerId]: newCountry }));
    setIsOpen({ isOpen: false, sellerId: '', sellerShippingCountries: [] });
  };

  useEffect(() => {
    retrieveItems(currentUser);
  }, [currentUser]);

  useEffect(() => {
    if (country !== {}) {
      const countriesObj = country;
      cartItems.data?.forEach(store => {
        countriesObj[store.sellerId]
          ? countriesObj[store.sellerId]
          : (countriesObj[store.sellerId] = 'US');
      });
      setCountry(countriesObj);
    }
  }, [cartItems, currentUser]);

  const isEmpty = !cartItems.data || cartItems.data.length == 0;
  const handleStorePurchase = sellerId => {
    const routes = routeConfiguration();
    // Redirect to CheckoutPage
    history.replace(createResourceLocatorString('CheckoutPage', routes, {}, { sellerId }));
  };

  return (
    <Page
      className={css.root}
      contentType="website"
      title="shopping cart"
      scrollingDisabled={false}
    >
      <ShippingModal
        sellerShippingCountries={isOpen.sellerShippingCountries}
        sellerId={isOpen.sellerId}
        handleSubmit={handleSubmit}
        setCountry={setCountry}
        isOpen={isOpen.isOpen}
        setIsOpen={setIsOpen}
        country={country || {}}
      />
      <LayoutWrapperTopbar>{topbar}</LayoutWrapperTopbar>
      <LayoutWrapperMain className={css.mainLayout}>
        <div>
          {!isEmpty ? (
            <h2 className={css.title}>
              <FormattedMessage id="ShoppingCart.shoppingCartTitle" />
            </h2>
          ) : null}
        </div>
        {console.log('cartItems', cartItems)}
        {!loading &&
          cartItems.data &&
          cartItems?.data?.map(purchaseData => (
            <StorePurchase
              currentUser={currentUser}
              handleStorePurchase={handleStorePurchase}
              currency={purchaseData.currency}
              intl={intl}
              sellerId={purchaseData.sellerId}
              country={country}
              key={purchaseData.sellerId}
              removeItem={removeItem}
              purchaseData={purchaseData}
              editAmount={editAmount}
              handleOpenModal={e => handleOpenModal(e, purchaseData.products)}
              shippingCost={cart[`shippingCost-${purchaseData.sellerId}`]}
            />
          ))}
        {isEmpty ? (
          <div className={css.emptyState}>
            <div className={css.image}>
              <img src={image}></img>
            </div>
            <h3 className={css.title}>
            Oops, your cart is empty! Add some fan-made items to your cart to support your fandom's Merch Makers
            </h3>
            <div className={css.linkWrapper}>
              <NamedLinkButton name="SearchPage">Start shopping</NamedLinkButton>
            </div>
          </div>
        ) : null}
      </LayoutWrapperMain>
    </Page>
  );
}

ShoppingCart.propTypes = {};

const mapStateToProps = (state, sdk) => {
  const { isAuthenticated } = state.Auth;
  const { currentUser } = state.user;
  const { cartItems, error, loading, shippingCost } = state.ShoppingCart;
  const { ShoppingCart: cart } = state;
  const {
    listing,
    orderData,
    stripeCustomerFetched,
    speculateTransactionInProgress,
    speculateTransactionError,
    speculatedTransaction,
    transaction,
    initiateOrderError,
    confirmPaymentError,
  } = state.CheckoutPage;
  return {
    cartItems,
    error,
    loading,
    isAuthenticated,
    shippingCost,
    cart,
    listing,
    orderData,
    stripeCustomerFetched,
    speculateTransactionInProgress,
    speculateTransactionError,
    speculatedTransaction,
    transaction,
    initiateOrderError,
    confirmPaymentError,
    listing,
    orderData,
    stripeCustomerFetched,
    speculateTransactionInProgress,
    speculateTransactionError,
    speculatedTransaction,
    transaction,
    initiateOrderError,
    confirmPaymentError,
    currentUser,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    retrieveItems: user => dispatch(getItems(user)),
    removeItem: (listingId, user) => dispatch(removeItem(listingId, user)),
    editAmount: (listingId, quantity, user) => dispatch(changeAmount(listingId, quantity, user)),
    initiateOrder: () => dispatch(initiateOrder(orderParams, transactionId)),
    calculateShipping: (products, sellerId, sellerShippingData, buyerCountry) =>
      dispatch(shippingFeeCalculation(products, sellerId, sellerShippingData, buyerCountry)),
  };
};

const exportShoppingCart = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ShoppingCart);

export default exportShoppingCart;
